export const CommissionsPages = {
	Commissions: {
		name: "commissions",
		displayName: "Commissions",
	},
	AddRevenueSource: {
		name: "add-revenue-source",
		displayName: "Add Revenue Source",
	},
	EditRevenueSource: {
		name: "edit-revenue-source",
		displayName: "Edit Revenue Source",
	},
};
